import Hero from '../components/Hero';
import Problem from '../components/Problem';
import Results from '../components/Results';
import HowItWorks from '../components/HowItWorks';
import Value from '../components/Value';
import TestimonialSlider from '../components/TestimonialSlider';
import FAQ from '../components/FAQ';
import Closing from '../components/Closing';
import FloatingCTA from '../components/FloatingCTA';
import Footer from '../components/Footer';
import { usePageView } from '../hooks/usePageView';
import { useScrollTracking } from '../hooks/useScrollTracking';
import { useWistiaTracking } from '../hooks/useWistiaTracking';

export default function Home() {
  usePageView('page_view_offer');
  useScrollTracking({ event50: 'scroll_50_offer', event90: 'scroll_90_offer' });
  useWistiaTracking('i2noi2bvrw');

  return (
    <>
      <Hero />
      <Problem />
      <Results />
      <HowItWorks />
      <Value />
      <TestimonialSlider />
      <FAQ />
      <Closing />
      <FloatingCTA />
      <Footer />
    </>
  );
}
